import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const listItemHeaderCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;box-sizing:border-box;color:var(--jw-theme-surface-text-helper-color);display:flex;flex:none;font-family:Open Sans;font-size:.875rem;font-size:.75rem;font-weight:400;font-weight:700;height:1.5rem;letter-spacing:-.0004em;letter-spacing:.03em;line-height:1.25rem;line-height:normal;line-height:1rem;list-style:none;overflow:hidden;padding-left:.75rem;pointer-events:none;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiListItemHeader = /*@__PURE__*/ proxyCustomElement(class WuiListItemHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    render() {
        return (h(Host, { key: '716d4a1b85f3aeb2cc0aa2793e690d8dbc3b3725', role: "listitem", tabIndex: -1 }, this.label));
    }
    static get style() { return listItemHeaderCss; }
}, [257, "wui-list-item-header", {
        "label": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-list-item-header"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiListItemHeader);
            }
            break;
    } });
}
defineCustomElement();

export { WuiListItemHeader as W, defineCustomElement as d };
